import NotificationDropdown from './NotificationsDropdown';

export default NotificationDropdown;
